<template>
  <section class="is-flex">
    <FormMultiSelect
      v-model="filter.operator"
      :config="dateQueryOperatorConfig"
      :rules="{ required: true }"
      :show-float-label="false"
      :data-e2e="TableCypressAttribute.filter.inputs.OPERATORS"
    />
    <div class="is-flex" :class="{ 'is-split': isBetween }">
      <FormDate
        v-model="filter.value"
        :placeholder="$t('accounting.from')"
        :format="format"
        :rules="{ required: true }"
        class="m-l-10"
        :data-e2e="TableCypressAttribute.filter.inputs.VALUE_DATE_ELEMENT"
        :max-date="computedMaxDate"
      />
      <div v-if="isBetween">
        <FormDate
          v-model="filter.secondValue"
          :placeholder="$t('accounting.to')"
          :format="format"
          :rules="{ required: true }"
          position="is-bottom-left"
          class="m-l-10"
          :data-e2e="TableCypressAttribute.filter.inputs.SECOND_VALUE_DATE_ELEMENT"
          :max-date="computedMaxDate"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FormMultiSelect from '/@/modules/core/form/components/FormMultiSelect.vue';
import FormDate from '/@/modules/core/form/components/FormDate.vue';
import { FormSelectConfig } from '/@/modules/core/form/models/FormSelectConfig';
import { DateFormat } from '/@/modules/core/app/constants/date.constants';
import { TableFilter } from '/@/modules/core/table/models/TableFilter';
import { UrlQueryOperator } from '/@/modules/core/app/constants/UrlQueryOperator';
import { TableCypressAttribute } from '/@/modules/core/table/constants/TableCypressAttribute';
import Lang from '/@/modules/core/app/services/Lang';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DateTableFilter',
  components: { FormDate, FormMultiSelect },
  props: {
    tableFilter: {
      type: TableFilter,
      required: true
    },
    maxDate: {
      type: Date
    }
  },
  static: {
    TableCypressAttribute
  },
  local() {
    return {
      format: DateFormat.ISO
    };
  },
  data() {
    return {
      filter: this.tableFilter,
      date: null,
      endDate: null,
      dateQueryOperator: null,
      dateQueryOperatorConfig: new FormSelectConfig({
        options: [
          {
            key: UrlQueryOperator.LESS_THAN.key,
            value: Lang.t('core.before')
          },
          {
            key: UrlQueryOperator.GREATER_THAN.key,
            value: Lang.t('core.after')
          },
          {
            key: UrlQueryOperator.BETWEEN.key,
            value: Lang.t('core.between')
          }
        ]
      })
    };
  },
  computed: {
    isBetween() {
      return this.tableFilter.operator === UrlQueryOperator.BETWEEN.key;
    },
    computedMaxDate() {
      return this.maxDate ?? new Date();
    }
  }
};
</script>
